














import Component from 'vue-class-component'
import Vue from 'vue'
import UnifyButton from '@/shared/components/unify/unify-button.vue'
import UnifyList from '@/shared/components/unify/unify-list.vue'
import UnifyListItem from '@/shared/components/unify/unify-list-item.vue'
import UnifyListItemContent from '@/shared/components/unify/unify-list-item-content.vue'
import RespondecoEditor from '@/shared/components/respondeco-editor.vue'
import RespondecoFormGroup from '@/shared/components/respondeco-form-group.vue'
import RespondecoValidationFeedback from '@/shared/components/respondeco-validation-feedback.vue'

@Component({
  name: 'new-project-description',
  components: {
    RespondecoValidationFeedback,
    RespondecoFormGroup,
    RespondecoEditor,
    UnifyListItemContent,
    UnifyListItem,
    UnifyList,
    UnifyButton,
  },
})
export default class NewProjectDescription extends Vue {}
